import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice.ts";

type Props = {
  cost: number;
};

export default function VehicleOfferBuyCost({ cost }: Props) {
  const { t } = useTranslation("offer");
  return (
    <div className="mb-5">
      <div className="text-18 font-bold text-accent-solid">{formatPrice(cost)} ₽</div>
      <div className="text-15 font-medium text-gray/50">{t("offer.vehicle.resolver.cost")}</div>
    </div>
  );
}
